<script>
  // steps = array of labels; active = 0-based index.
  //
  // Optionally each step carries a route, which turns the stepper into the
  // navigation it already looks like: the analyst reads the steps at the top of
  // every screen, so asking them to scroll to the bottom to move between them is
  // a detour.
  //
  // `blocks(i)` says why step i cannot be reached yet, or null if it can. A
  // blocked step stays a plain label carrying that reason — the stepper must
  // never offer a move the step's own gate would refuse.
  import { go } from '../lib/nav.svelte.js';

  let { steps = [], active = 0, routes = null, blocks = () => null } = $props();

  const linkable = (i) => i !== active && Boolean(routes?.[i]) && !blocks(i);
</script>

<div class="wf2-stepper">
  {#each steps as label, i}
    {#if linkable(i)}
      <button class="wf2-step" onclick={() => go(routes[i])}>{i + 1}. {label}</button>
    {:else}
      <div class="wf2-step {i === active ? 'active' : ''}" title={blocks(i) ?? ''}>{i + 1}. {label}</div>
    {/if}
  {/each}
</div>
